import colors from "./color.module.scss";

type StyleType = {
  primary_custom: string;
  secondary_custom: string;
  success_custom: string;
  danger_custom: string;
  warning_custom: string;
  info_custom: string;
  dark_custom: string;
  primary_light_custom: string;
  secondary_light_custom: string;
  success_light_custom: string;
  danger_light_custom: string;
  warning_light_custom: string;
  info_light_custom: string;
  dark_light_custom: string;
  navy_custom: string;
  orange_custom: string;
  pink_custom: string;
  blue_custom: string;
  red_custom: string;
  black_custom: string;
  white_custom: string;
};

const ColorSchema: StyleType = {
  primary_custom: colors.primary_custom,
  secondary_custom: colors.secondary_custom,
  success_custom: colors.success_custom,
  danger_custom: colors.danger_custom,
  warning_custom: colors.warning_custom,
  info_custom: colors.info_custom,
  dark_custom: colors.dark_custom,
  primary_light_custom: colors.primary_light_custom,
  secondary_light_custom: colors.secondary_light_custom,
  success_light_custom: colors.success_light_custom,
  danger_light_custom: colors.danger_light_custom,
  warning_light_custom: colors.warning_light_custom,
  info_light_custom: colors.info_light_custom,
  dark_light_custom: colors.dark_light_custom,
  navy_custom: colors.navy_custom,
  orange_custom: colors.orange_custom,
  pink_custom: colors.pink_custom,
  blue_custom: colors.blue_custom,
  red_custom: colors.red_custom,
  black_custom: colors.black_custom,
  white_custom: colors.white_custom,
};

export default ColorSchema;
